import { LayoutHOC } from "base/ui/layout/layout";
import { createDiagramMachine } from "./diagram";


export const createDiagramMachinePage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createDiagramMachine());
};